import { render, staticRenderFns } from "./pagina.vue?vue&type=template&id=a9c8c814&"
import script from "./pagina.vue?vue&type=script&lang=js&"
export * from "./pagina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports